// src/data/hireAndroidPageData.js

export const hireAndroidPageContentArabic = {
  // Helmet Content
  helmet: {
    title: "وظّف مطوري Android | تطوير تطبيقات الجوال المخصصة",
    description: "هل تتطلع لتوظيف مطوري أندرويد؟ اعمل مع محترفين ذوي خبرة لبناء تطبيقات أندرويد مبتكرة وسهلة الاستخدام. اتصل بنا اليوم لبدء مشروعك!",
  },

  // Main Banner Content
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/hire-android-page.avif)`,
    image: "",
    mainHeading: "توظيف مطوري تطبيقات أندرويد",
    content: "شريكك الموثوق لخدمات تطوير تطبيقات أندرويد المتخصصة، والمصممة خصيصًا للشركات الناشئة والمؤسسات. قم ببناء تطبيقات جوال عالية الأداء وقابلة للتطوير ومبتكرة مع مطورينا المهرة.",
    btnText: "استشر مطوري أندرويد لدينا اليوم",
    bannerList: [
      { list: "مقاولين مستقلين" },
      { list: "وظائف بدوام كامل" },
      { list: "فرق عالمية" },
    ],
  },

  // Android Expertise Section
  androidExpertise: {
    btnText: "حدد موعدًا لإجراء مكالمة اليوم",
    heading: "خبرتنا في تطوير أندرويد",
    description: "يتخصص مطورو أندرويد لدينا في بناء تطبيقات جوال عالية الأداء، بديهية، وغنية بالميزات، مما يضمن وظائف سلسة وتجربة مستخدم متميزة على جميع أجهزة أندرويد.",
    servicesData: [
      {
        title: "استشارات تطبيقات أندرويد",
        description: " احصل على توجيه استراتيجي ومشورة خبراء لتحسين تطوير تطبيقات أندرويد الخاصة بك وزيادة إمكاناتها.",
        icon: "/images/hire-page-icons/hire-android-icon1.svg",
      },
      {
        title: "تطوير تطبيقات أندرويد",
        description: "استفد من خبرة مطورينا لبناء تطبيقات أندرويد قابلة للتطوير وغنية بالميزات تدفع التفاعل والأداء.",
        icon: "/images/hire-page-icons/hire-android-icon2.svg",
      },
      {
        title: "تطوير واجهة برمجة تطبيقات أندرويد (API)",
        description: "تطوير واجهات برمجة تطبيقات قوية تمكّن الاتصال السلس بين تطبيقات الجوال وخدمات الطرف الثالث.",
        icon: "/images/hire-page-icons/hire-android-icon3.svg",
      },
      {
        title: "تطوير نظام إدارة المحتوى (CMS) وبوابات أندرويد",
        description: "إنشاء أنظمة متقدمة لإدارة المحتوى وبوابات ويب مع مطوري أندرويد الخبراء لدينا.",
        icon: "/images/hire-page-icons/hire-android-icon4.svg",
      },
      {
        title: "الترحيل إلى أندرويد",
        description: "قم بترحيل تطبيقاتك المحمولة الحالية إلى أندرويد بسهولة مع ضمان انتقال سلس وسلامة البيانات.",
        icon: "/images/hire-page-icons/hire-android-icon5.svg",
      },
      {
        title: "التكامل مع الحلول الحالية",
        description: " دمج تطبيقات أندرويد بسلاسة مع مختلف المنصات والخدمات وأنظمة المؤسسات لوظائف محسّنة.",
        icon: "/images/hire-page-icons/hire-android-icon6.svg",
      },
      {
        title: "حلول التجارة الإلكترونية لأندرويد",
        description: "استفد من خبرة مطوري أندرويد لدينا لبناء حلول تجارة إلكترونية عالية الأداء تعزز تجربة المستخدم والتفاعل، مما يضمن تجارب تسوق سلسة.",
        icon: "/images/hire-page-icons/hire-android-icon7.svg",
      },
      {
        title: "دعم وصيانة أندرويد",
        description: " حافظ على استقرار تطبيقات أندرويد الخاصة بك وكفاءتها وتحديثها من خلال خدمات الدعم والصيانة المخصصة والفعالة لدينا.",
        icon: "/images/hire-page-icons/hire-android-icon8.svg",
      },
    ],
  },

  // Why Choose Us (Development Performance)
  whyChooseUs: {
    btnText: "توظيف مطور اليوم",
    heading: "لماذا تختار بيتسكلان لتوظيف ",
    greenHeading: "مُطوري أندرويد؟",
    subHeading: "نحن نستفيد من أحدث تقنيات أندرويد لتطوير تطبيقات قوية وقابلة للتطوير ومخصصة تتوافق مع أهداف عملك. سواء لمنصات الجوال أو الويب، نضمن أداءً سلسًا وتطويرًا أسرع وتجربة مستخدم استثنائية لتطبيقات أندرويد الخاصة بك.",
    solutionsData: [
      {
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
        title: "الوصول إلى المواهب المدققة",
        description: "قم بتوظيف كبار مطوري أندرويد بسهولة من ذوي المهارات المناسبة وقدرات التواصل القوية. تضمن عملية التدقيق الصارمة لدينا أفضل تطابق لمشروعك.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "عرض التطابقات في ثوانٍ",
        description: "تجاوز مراجعات السيرة الذاتية المطولة! باستخدام HireAI، يمكنك اكتشاف مطوري أندرويد المؤهلين بسرعة واختيار الأنسب لفريقك.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
        title: "وفر مع التوظيف العالمي",
        description: "الوصول إلى مجموعة متنوعة من المهنيين ذوي المهارات العالية في جميع أنحاء العالم مع تحسين التكاليف وتأمين أفضل المواهب لمشاريعك.",
        noBorder: true,
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
        title: "احصل على دعم بشري حقيقي",
        description: "فريق التوظيف المخصص لدينا هنا لمساعدتك في كل خطوة، مما يضمن تجربة توظيف سلسة وخالية من المتاعب.",
      },
    ],
  },

  // Technology Combinations
  techCombinations: {
    heading: "أفضل تركيبات تقنية أندرويد لتطوير متفوق",
    description: "استفد من قوة تقنيات أندرويد المتطورة عن طريق توظيف مطورين خبراء. افتح الأداء السلس، وقابلية التوسع، والابتكار مع أفضل تركيبات التقنيات لحلول أندرويد الخاصة بك.",
    combinations: [
      {
        title: "Kotlin + Firebase",
        description: "يضمن Kotlin كلغة مفضلة لتطوير أندرويد جنبًا إلى جنب مع Firebase قاعدة بيانات في الوقت الفعلي، ومصادقة، ووظائف سحابية لتطبيقات الجوال.",
        icons: ["kotlin.svg", "firebase.png"],
      },
      {
        title: "Kotlin + Jetpack Compose + Room Database",
        description: "يوفر Kotlin مع Jetpack Compose تطوير واجهة مستخدم حديثة، بينما تضمن قاعدة بيانات Room تخزينًا فعالًا للبيانات المحلية لتطبيقات أندرويد.",
        icons: ["kotlin.svg", "jetpack-compose.svg", "room.svg"],
      },
      {
        title: "Java + Retrofit + MySQL",
        description: "Java لتطوير أندرويد، و Retrofit لتكامل API سلس، و MySQL كقاعدة بيانات علائقية منظمة لتطبيقات قابلة للتطوير.",
        icons: ["java.svg", "retrofit.svg", "mysql-whale-icon.svg"],
      },
      {
        title: "Kotlin + MVVM + SQLite",
        description: "يضمن Kotlin مع بنية MVVM تطبيقات أندرويد قابلة للتطوير والصيانة، بينما يوفر SQLite حلاً خفيف الوزن لقاعدة البيانات المحلية.",
        icons: ["kotlin.svg", "mvv.svg", "sq-lite.svg"],
      },
      {
        title: "Flutter + Firebase",
        description: "يوفر Flutter لتطوير تطبيقات الجوال عبر الأنظمة الأساسية و Firebase لقاعدة البيانات في الوقت الفعلي، والمصادقة، وخدمات الواجهة الخلفية حلاً كاملاً للجوال.",
        icons: ["Flutter.svg", "firebase.png"],
      },
      {
        title: "React Native + GraphQL + PostgreSQL",
        description: "React Native لتطوير تطبيقات الجوال عبر الأنظمة الأساسية، و GraphQL لاستعلامات البيانات المحسّنة، و PostgreSQL لإدارة قواعد البيانات المنظمة.",
        icons: ["react.svg", "graphql.svg", "postgres.svg"],
      },
    ],
  },

  // Hire Steps
  hireSteps: {
    btnText: "دعنا نجد المطور المثالي لك",
    heading: "قم بتوظيف مطوري أندرويد في 4 خطوات سهلة",
    subHeading: "توظيف مطوري أندرويد سريع وخالٍ من المتاعب من خلال عمليتنا المبسطة المكونة من 4 خطوات. ابحث عن المطابق المثالي لمشروعك في وقت قصير.",
    steps: [
      {
        title: "اختر نموذج التعاقد الخاص بك",
        description: "اختر نموذج التوظيف الذي يناسب احتياجاتك - دوام كامل، دوام جزئي، أو بالساعة - بناءً على نطاق مشروعك ومتطلبات التطوير.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
      },
      {
        title: "فحص واختيار مطوري أندرويد",
        description: "تصفح مطوري أندرويد المدققين مسبقًا، وراجع ملفاتهم الشخصية، وقم بوضع قائمة مختصرة بالمرشحين ذوي الخبرة المناسبة لمشروعك.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
      },
      {
        title: "إجراء مقابلة فردية",
        description: "قم بمقابلة المطورين المختارين لتقييم مهاراتهم التقنية وقدراتهم على حل المشكلات وخبرتهم في تطوير أندرويد قبل اتخاذ القرار.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
      },
      {
        title: "التوظيف والبدء",
        description: "بمجرد اختيارك، سينضم مطور أندرويد الخاص بك إلى فريقك في غضون 24-48 ساعة، وسيكون جاهزًا للمساهمة فورًا.",
        icon: "/images/hire-page-setps-icons/icon-4.svg",
      },
    ],
  },

  // Cover The Stack
  coverTheStack: {
    whereStart: "الأدوات والمرافق",
    mainHeading: "استأجر خبراء تطوير أندرويد لتطبيقات قابلة للتطوير وعالية الأداء",
    subHeading: "في بيتسكلان، ندعم رحلة تطوير تطبيقات أندرويد الخاصة بك بمجموعة تقنية منتقاة بعناية تضمن الكفاءة وقابلية التوسع. يستفيد مطورونا ذوو الخبرة في أندرويد من التقنيات المتطورة لبناء تطبيقات أندرويد مخصصة تلبي احتياجات عملك، وتقدم أداءً سلسًا ومشاركة المستخدم.",
    tabs: [
      "الأدوات والمرافق",
      "اللغات والأطر",
      "المكتبات والمكونات ومجموعات الأدوات",
      "أدوات ضمان الجودة وأدوات البناء",
      "قواعد البيانات والتخزين",
    ],
    tabItems: [
      { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/android-studio.svg", name: "بيئة تطوير أندرويد ستوديو" },
      { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/android-studio.svg", name: "محاكي أندرويد" },
      { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/leak-canary.svg", name: "LeakCanary" },
      { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/vysor.svg", name: "Vysor" },
      { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/zeplin.svg", name: "Zeplin" },
      { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/figma.svg", name: "Figma" },
      { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/jira.svg", name: "Jira" },
      { tab: "اللغات والأطر", icon: "/images/tech-stack-icons/java.svg", name: "Java" },
      { tab: "اللغات والأطر", icon: "/images/tech-stack-icons/kotlin.svg", name: "Kotlin" },
      { tab: "اللغات والأطر", icon: "/images/tech-stack-icons/android-sdk.svg", name: "Android SDK" },
      { tab: "اللغات والأطر", icon: "/images/tech-stack-icons/jetpack-compose.svg", name: "Jetpack Compose" },
      { tab: "اللغات والأطر", icon: "/images/tech-stack-icons/android-jetpack.svg", name: "Android Jetpack" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/rx-js.svg", name: "RxJava" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/kotlin-coroutines.svg", name: "Kotlin Coroutines" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/kotlin.svg", name: "Kotlin Flow" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/koin.svg", name: "KOIN" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/retrofit.svg", name: "Retrofit" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/moshi.svg", name: "Moshi" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/glide.svg", name: "Glide" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/work-manager.svg", name: "WorkManager" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/jetpack-room.svg", name: "Jetpack Room" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/jetpack-view-model.svg", name: "Jetpack ViewModel" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/jetpack-navigation.svg", name: "Jetpack Navigation" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/jetpack-lifecycle.svg", name: "Jetpack Lifecycle" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/material-ui.svg", name: "Material Components" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/view-components", name: "View Components" },
      { tab: "المكتبات والمكونات ومجموعات الأدوات", icon: "/images/tech-stack-icons/android-jetpack.svg", name: "JJetpack ViewModel" },
      { tab: "أدوات ضمان الجودة وأدوات البناء", icon: "/images/tech-stack-icons/j-unit.svg", name: "JUnit" },
      { tab: "أدوات ضمان الجودة وأدوات البناء", icon: "/images/tech-stack-icons/mockito.svg", name: "Mockito" },
      { tab: "أدوات ضمان الجودة وأدوات البناء", icon: "/images/tech-stack-icons/espresso.svg", name: "Espresso" },
      { tab: "أدوات ضمان الجودة وأدوات البناء", icon: "/images/tech-stack-icons/gradle.svg", name: "Gradle" },
      { tab: "أدوات ضمان الجودة وأدوات البناء", icon: "/images/tech-stack-icons/jenkins.svg", name: "Jenkins" },
      { tab: "أدوات ضمان الجودة وأدوات البناء", icon: "/images/tech-stack-icons/gitlab.svg", name: "GitLab CI/CD" },
      { tab: "قواعد البيانات والتخزين", icon: "/images/tech-stack-icons/firebase.png", name: "Firebase" },
      { tab: "قواعد البيانات والتخزين", icon: "/images/tech-stack-icons/room.svg", name: "Room" },
      { tab: "قواعد البيانات والتخزين", icon: "/images/tech-stack-icons/sq-lite.svg", name: "SQ Lite" },
      { tab: "قواعد البيانات والتخزين", icon: "/images/tech-stack-icons/shared-preference.svg", name: "Shared Preference" },
    ],
  },

  // Expert Facts
  expertFacts: {
    btnText: "حجز موعد",
    heading: "حقائق سريعة حول ",
    greenHeading: "فريق أندرويد لدينا",
    facts: [
      {
        text: "أكثر من 20 مطور أندرويد ماهر متخصصون في تطوير تطبيقات أندرويد المخصصة.",
      },
      {
        text: "أكثر من 10 سنوات من الخبرة المشتركة في بناء تطبيقات الجوال عالية الجودة.",
      },
      { text: "خبرة في Android SDK و Kotlin و Java، وهي التقنيات الأساسية لتطوير أندرويد." },
      {
        text: "تطبيقات حية على Google Play—لقد أطلق مطورونا بنجاح العديد من تطبيقات أندرويد المخصصة.",
      },
      { text: "حلول جوال قابلة للتطوير تقدم أداءً سلسًا على كل من الهواتف والأجهزة اللوحية." },
      { text: "خبرة على مستوى المؤسسات في تطوير حلول جوال قوية ودمج واجهات برمجة تطبيقات الطرف الثالث في تطبيقات أندرويد." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-android-page-arabic.avif)`,
  },

  // App Idea Section
  appIdeaSection: {
    heading: "حوّل فكرة تطبيقك إلى نموذج أولي عامل في غضون أسابيع قليلة!",
    content: "هل لديك فكرة ولكنك غير متأكد من كيفية المتابعة؟ يساعدك فريقنا على تحويل رؤيتك إلى نموذج أولي عامل في غضون 6-8 أسابيع. يتيح لك هذا التحقق من صحة مفهومك، واختبار مشاركة المستخدم، وبناء أساس قوي لنجاح مشروعك—كل ذلك بخبرة خدمات تطوير أندرويد لدينا.",
  },

  // Engagement Models
  hirePageEngagementModels: {
    btnText: "ابدأ الآن",
    headingContent: [
      { text: "نماذج التعاقد" },
      { text: "المرنة لدينا" },
    ],
    discription: "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل، أو بدوام جزئي، أو بالساعة، فإننا نقدم خيارات مرنة لضمان التعاون السلس وأقصى قدر من الكفاءة طوال مشروعك.",
    hiringDetails: [
      {
        text: "التوظيف بالساعة",
        hours: "48",
        timeUnit: "ساعة",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يوم",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ العمل في "
      },
      {
        text: "التوظيف بدوام كامل",
        hours: "72",
        timeUnit: "ساعة",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يوم",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ في غضون "
      },
      {
        text: "التوظيف بدوام جزئي",
        hours: "48",
        timeUnit: "ساعة",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يوم",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "انطلق في "
      },
    ],
  },

  // FAQ Section
  faqSection: {
    mainHeading: "الأسئلة المتكررة",
    subHeading: "اكتشف إجابات لأسئلة شائعة حول تطوير أندرويد.",
    faqData: [
      {
        id: "collapseOne",
        question: "ما هو تطوير تطبيقات أندرويد؟",
        answer: "تطوير تطبيقات أندرويد هو عملية إنشاء تطبيقات للأجهزة التي تعمل بنظام أندرويد، مثل الهواتف الذكية والأجهزة اللوحية. يتضمن ذلك البرمجة والتصميم واختبار التطبيقات لضمان عملها بسلاسة.",
      },
      {
        id: "collapseTwo",
        question: "لماذا يجب علي توظيف مطوري أندرويد من Bitsclan؟",
        answer: "من خلال توظيف مطوري أندرويد من Bitsclan، تحصل على إمكانية الوصول إلى خبراء يمتلكون المهارات والخبرة المناسبة في تطوير تطبيقات أندرويد. نضمن تطبيقات عالية الجودة وقابلة للتطوير تلبي احتياجات عملك.",
      },
      {
        id: "collapseThree",
        question: "هل يمكنك المساعدة في ترحيل تطبيقي الحالي إلى أندرويد؟",
        answer: "نعم! يمكن لخبراء أندرويد لدينا مساعدتك في ترحيل تطبيقاتك المحمولة الحالية إلى أندرويد. نضمن انتقالًا سلسًا، مع الحفاظ على جميع وظائف تطبيقك أثناء ترقيته للعمل بشكل مثالي على أجهزة أندرويد.",
      },
      {
        id: "fourth",
        question: "هل تقدمون تطوير تطبيقات عبر الأنظمة الأساسية؟",
        answer: "نعم، نحن نفعل ذلك! يتخصص مطورونا في إنشاء تطبيقات عبر الأنظمة الأساسية باستخدام Flutter وأدوات أخرى، بحيث يمكن لتطبيقك العمل على كل من أندرويد و iOS دون الحاجة إلى تطوير منفصل لكل منهما.",
      },
      {
        id: "fifth",
        question: "ما أنواع تطبيقات أندرويد التي يمكنكم بناؤها؟",
        answer: "يمكننا بناء جميع أنواع تطبيقات أندرويد، بما في ذلك التجارة الإلكترونية، والشبكات الاجتماعية، وحلول المؤسسات، والمزيد. سواء كنت بحاجة إلى تطبيق بسيط أو تطبيق معقد مع تكاملات، فنحن نلبي احتياجاتك.",
      },
      {
        id: "sixth",
        question: "كم يستغرق تطوير تطبيق أندرويد؟",
        answer: "يعتمد وقت التطوير على مدى تعقيد التطبيق. يمكن تطوير التطبيقات البسيطة في بضعة أسابيع، بينما قد تستغرق التطبيقات الأكثر تعقيدًا بضعة أشهر. نقدم جداول زمنية واقعية بناءً على متطلبات مشروعك.",
      },
    ],
  },
};